import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/WizardHome.vue";
import UnderMaintenance from "@/views/_components/UnderMaintenance.vue";
import WizardOne from "../views/pages/WizardOne.vue";
import WizardTwo from "@/views/pages/WizardTwo.vue";
import WizardFour from "@/views/pages/WizardFour.vue";
import WizardEnd from "@/views/_components/WizardEnd.vue";
import CoveredInfo from "@/views/pages/covered_info/CoveredInfo.vue";
import Camera_iPodCoveredInfo from "@/views/pages/covered_info/camera-covered.vue";
import EReaderCoveredInfo from "@/views/pages/covered_info/ereader-covered.vue";
import GamingSystemCoveredInfo from "@/views/pages/covered_info/gamingsystem-covered.vue";
import IPadCoveredInfo from "@/views/pages/covered_info/ipad-covered.vue";
import LaptopCoveredInfo from "@/views/pages/covered_info/laptop-covered.vue";
import SmartphoneCoveredInfo from "@/views/pages/covered_info/smartphone-covered.vue";
import TabletCoveredInfo from "@/views/pages/covered_info/tablet-covered.vue";
import SerialNumber from "@/views/pages/SerialNumber.vue";

const app_config = require("../app_config.json");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "/step-one",
        name: "wizard.one",
        component: WizardOne,
      },
      {
        path: "/step-two",
        name: "wizard.two",
        component: WizardTwo,
      },
      {
        path: "/step-three",
        name: "wizard.three",
        component: WizardTwo,
      },
      {
        path: "/step-four",
        name: "wizard.four",
        component: WizardFour,
      },
      {
        path: "/step-final",
        name: "wizard.end",
        component: WizardEnd,
      },
      {
        path: "/maintenance",
        name: "maintenance",
        component: UnderMaintenance,
      },
    ],
  },
  {
    path: "/compare-iphone",
    name: "compare.iphone",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_IPHONE },
  },
  {
    path: "/compare-camera",
    name: "compare.camera",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_CAMERA },
  },
  {
    path: "/compare-ereader",
    name: "compare.ereader",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_ERADER },
  },
  {
    path: "/compare-gamingsystem",
    name: "compare.gamingsystem",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_GAMING },
  },
  {
    path: "/compare-ipad",
    name: "compare.ipad",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_IPAD },
  },
  {
    path: "/compare-laptop",
    name: "compare.laptop",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_LAPTOP },
  },
  {
    path: "/compare-smartphone",
    name: "compare.smartphone",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_PHONE },
  },
  {
    path: "/compare-tablet",
    name: "compare.tablet",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_TABLET },
  },
  {
    path: "/compare-smartwatch",
    name: "compare.smartwatch",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_SMARTWATCH },
  },
  {
    path: "/compare-applewatch",
    name: "compare.applewatch",
    component: CoveredInfo,
    props: { chartName: process.env.COVERED_APPLEWATCH },
  },
  {
    path: "/serial-number",
    name: "serial.number",
    component: SerialNumber,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = new VueRouter({
  base: app_config.home_url,
  mode: "history",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { x: 0, y: 0, behavior: "smooth" };
  },
});

Vue.router = router;
export default router;
